require('../templates/index.html');
require('../css/main.css');
import * as AFRAME from '../lib/aframe';
require( '../lib/aframe-animation-component');
require( '../lib/aframe-event-set');
require( '../lib/aframe-layout-component');
require( '../lib/aframe-template-component');
require( './components/change-raycaster');
require( './components/emit-event');
require( './components/hide-element');
require( './components/set-video');
require( './components/show-element');
require( './components/stop-video');
require( './components/toggle-video-mute');
require( './components/toggle-video');;



// WEBPACK FOOTER //
// ./js/index.js